import { combineReducers } from 'redux-merge-immutable-reducers';

import customer from './customer/customer';
import app from './app/app';
import gift_voucher from './giftVoucher/giftVoucher';
import notifications from '@synergycms_core/store/notifications/notifications';
import actions from './actions';
import { List, fromJS, Map } from 'immutable';
import { handleActions } from 'redux-actions';



//REDUCERS

const countries = handleActions(
  {
    [actions.countries.get.toString()]: (store, action) => {
      return fromJS(action.payload);
    }
  },
  List()
);

combineReducers({})

const tpv = handleActions(
  {
    [actions.tpv.get.toString()]: (store, action) => {
      return fromJS(action.payload);
    }
  },
  Map()
);

export default combineReducers({ customer, notifications, tpv, countries, gift_voucher, app });
